import React from 'react';

import PostGroup from '../PostGroup';
import PostGroupForex from '../PostGroup/PostGroupForex';

const PostGroupCategory = ({ isPostGroupForex = false, title, posts, linkLoadMore, isShowExcerptFirstPost }) => {
  
  if (isPostGroupForex) {
    return <PostGroupForex title={title} posts={posts} linkLoadMore={linkLoadMore}/>
  };

  return <PostGroup title={title} posts={posts} linkLoadMore={linkLoadMore} isShowExcerptFirstPost={isShowExcerptFirstPost} />;
};
export default PostGroupCategory;
